<template>
  <v-breadcrumbs
    class="px-0"
    divider=">"
    :items="breadcrumbs"
  >
    <template v-slot:item="{ item }">
      <v-btn
        v-if="mode === 'button'"
        plain
        :disabled="item.disabled"
        @click="clicked(item.folderId)"
      >{{ item.text }}</v-btn>
      <router-link v-if="mode === 'link'" :to="item.href">{{ item.text }}</router-link>
    </template>
  </v-breadcrumbs>
</template>

<script>
import { getFolderById } from './api';

const getUrl = (id) => `/system-admin/jump-start?folderId=${id}`;
const createBreadcrumb = (item) => ({ text: item.title, href: getUrl(item.id), folderId: item.id });
const createHomeBreadcrumb = () => ({ text: 'Home', href: '/system-admin/jump-start', folderId: null })

export default {
  data: () => ({
    breadcrumbs: [],
  }),
  props: {
    mode: {
      type: String,
      default: 'button',
    }
  },
  methods: {
    async create(parentId) {
      const breadcrumbs = [];

      if (parentId != null) {
        while (parentId != null) {
          const item = await getFolderById(parentId);
          const isRoot = item.id === 1;
          if (!isRoot) {
            breadcrumbs.push(createBreadcrumb(item));
          }
          parentId = item.parent_id;
        }
      }

      breadcrumbs.push(createHomeBreadcrumb());
      breadcrumbs.reverse();
      breadcrumbs[breadcrumbs.length - 1].disabled = true;

      this.breadcrumbs = breadcrumbs;
    },
    clicked(folderId) {
      this.$emit('breadcrumb-click', folderId);
    },
  },
}
</script>
